module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 042.07466a99.jpg";